import script from "./ExamHistoryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamHistoryView.vue?vue&type=script&setup=true&lang=ts"

import "./ExamHistoryView.vue?vue&type=style&index=0&id=740e62c8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740e62c8"]])

export default __exports__